<template>
  <div class="millage-card">
    <div class="millage-head">
      <div class="km">
        <span>Mile :</span>
        {{ millage.mileage.toLocaleString("en-US") }}
      </div>
      <q-btn flat dense>
        <q-icon size="12px" name="fas fa-ellipsis-h" color="grey-7"></q-icon>
        <q-menu content-class="text-grey-7" auto-close>
          <q-list style="min-width: 150px">
            <q-item
              clickable
              v-for="(item, index) in millageActions"
              :key="index"
              @click="item.method(millage)"
            >
              <q-item-section>{{ item.name }}</q-item-section>
            </q-item>
          </q-list>
        </q-menu>
      </q-btn>
    </div>
    <div class="mileage-mmr">
      <span>Auction:</span>
      {{
        currencyConventer(
          millage.market_values[0] ? millage.market_values[0].price : 0
        )
      }}
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      millageActions: [
        {
          name: "Delete",
          method: this.remove,
        },
        {
          name: "Edit",
          method: this.editFunc,
        },
      ],
    };
  },
  methods: {
    remove(millage) {
      this.confirm = true;
      this.selectedMillage = millage;
    },
    editFunc(millage) {
      this.edit = true;
      this.selectedMillage = millage;
    },
  },
  computed: {
    currencyConventer() {
      return (val) =>
        val.toLocaleString("en-US", {
          style: "currency",
          currency: "USD",
        });
    },
    edit: {
      get() {
        return this.$store.state.millage.edit;
      },
      set(val) {
        this.$store.commit("millage/SET_EDIT", val);
      },
    },
    confirm: {
      get() {
        return this.$store.state.millage.confirm;
      },
      set(val) {
        this.$store.commit("millage/SET_CONFIRM", val);
      },
    },
    selectedMillage: {
      get() {
        return this.$store.state.millage.selectedMillage;
      },
      set(val) {
        this.$store.commit("millage/SET_SELECTED_MILLAGE", val);
      },
    },
  },
  props: {
    millage: Object,
    index: Number,
  },
};
</script>

<style lang="scss">
.millage-card {
  background: #fff;
  margin: 5px;
  flex: 0 1 calc(25% - 10px);
  box-shadow: 0 0 20px #ccc;
  border-radius: 5px;
  padding: 10px;
  color: #000;
  font-weight: 300;
  .millage-head {
    display: flex;
    flex-flow: row nowrap;
    flex: 1;
    .km {
      align-items: center;
      line-height: 28px;
      flex: 1;
      justify-content: flex-end;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 1; /* number of lines to show */
      -webkit-box-orient: vertical;
      span {
        color: #000;
        font-weight: 700;
      }
    }
  }
  .mileage-mmr {
    display: flex;
    flex-flow: row nowrap;
    align-items: center;
    justify-content: flex-end;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 1; /* number of lines to show */
    -webkit-box-orient: vertical;
    span {
      margin-right: 5px;
      font-weight: 700;
      color: #000;
      margin-top: -2px;
    }
  }
}
</style>
